import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoginComponent } from '../login/login.component';

@Component({
  selector: 'app-success',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './success.component.html',
  styleUrl: './success.component.scss'
})
export class SuccessComponent implements OnInit, OnDestroy {
  type: 'success' | 'error' | 'warning' = 'success';
  message: string = 'Your request has been received!';
  subMessage: string = '';
  title: string = '';
  isLoginPrompt: boolean = false;
  private autoCloseTimer: any;

  constructor(
    private dialogRef: MatDialogRef<SuccessComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private matDialog: MatDialog
  ) {
    if (data) {
      this.type = (data?.type === 'error' || data?.type === 'warning') ? data.type : 'success';
      this.message = data?.message || (this.type === 'error' ? 'An unexpected error occurred.' : 'Operation completed successfully.');
      this.subMessage = data?.subMessage || '';
      this.title = data?.title || '';
    }

    const lower = (this.message || '').toLowerCase();
    this.isLoginPrompt = lower.includes('login') || lower.includes('log in');
  }

  ngOnInit(): void {
    // Auto-dismiss clean success alerts after 4.5s
    if (this.type === 'success' && !this.isLoginPrompt) {
      this.autoCloseTimer = setTimeout(() => {
        this.close(true);
      }, 4500);
    }
  }

  close(status: boolean = false): void {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
    }
    this.dialogRef.close(status);
  }

  openLogin(): void {
    this.close(false);
    this.matDialog.open(LoginComponent, {
      width: '420px',
      disableClose: true
    });
  }

  ngOnDestroy(): void {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
    }
  }
}
